import FormContentCreateOrEditCreatorPaymentMethodBankTransfert from './FormContentCreateOrEditCreatorPaymentMethodBankTransfert';
import FormContentCreateOrEditCreatorPaymentMethodMobileMoney from './FormContentCreateOrEditCreatorPaymentMethodMobileMoney';
import FormContentCreateOrEditCreatorPaymentMethodPaypal from './FormContentCreateOrEditCreatorPaymentMethodPaypal';
import { PaymentMethodEnum } from '@/enums';
import { useWatch } from 'react-hook-form';
import { TProps } from '..';

const FormContentCreateOrEditCreatorPaymentMethod = ({ fieldNames, readonly = false }: TProps) => {

  const paymentMethod = useWatch({ name: fieldNames.paymentInfo.method });

  if (paymentMethod === PaymentMethodEnum.BANK_TRANSFERT) {
    return (
      <FormContentCreateOrEditCreatorPaymentMethodBankTransfert
        fieldNames={fieldNames}
        readonly={readonly} />
    );
  }

  if (paymentMethod === PaymentMethodEnum.MOBILE_MONEY) {
    return (
      <FormContentCreateOrEditCreatorPaymentMethodMobileMoney
        fieldNames={fieldNames}
        readonly={readonly} />
    );
  }

  if (paymentMethod === PaymentMethodEnum.PAYPAL) {
    return (
      <FormContentCreateOrEditCreatorPaymentMethodPaypal
        fieldNames={fieldNames}
        readonly={readonly} />
    );
  }

  return <></>;

};

export default FormContentCreateOrEditCreatorPaymentMethod;
